import { Controller } from "@hotwired/stimulus"

const COUNT_COOKIE = "like_hint_count"
const SNOOZE_COOKIE = "like_hint_snooze"
const SHOWS_WITHOUT_SNOOZE = 3
const FIRST_SNOOZE_SECONDS = 5 * 60
const MAX_SNOOZE_SECONDS = 24 * 60 * 60
const COUNT_MAX_AGE_SECONDS = 365 * 24 * 60 * 60
const SHOW_DELAY_MS = 1500
const VISIBLE_MS = 8000
const FADE_MS = 500

const readCookie = name => document.cookie.split("; ").find(pair => pair.startsWith(`${name}=`))?.split("=")[1]

const writeCookie = (name, value, maxAge) => {
  document.cookie = `${name}=${value}; path=/; max-age=${maxAge}; samesite=lax`
}

const snoozeSecondsAfter = shownCount =>
  shownCount < SHOWS_WITHOUT_SNOOZE ? 0 : Math.min(FIRST_SNOOZE_SECONDS * 2 ** (shownCount - SHOWS_WITHOUT_SNOOZE), MAX_SNOOZE_SECONDS)

export default class extends Controller {
  connect() {
    if (this.element.classList.contains("hidden")) this.schedule()
    else this.element.remove()
  }

  disconnect() {
    clearTimeout(this.timer)
  }

  schedule() {
    if (this.shown) return

    clearTimeout(this.timer)
    if (!document.hidden) this.timer = setTimeout(() => this.show(), SHOW_DELAY_MS)
  }

  show() {
    if (readCookie(SNOOZE_COOKIE)) return

    this.shown = true
    const shownCount = this.shownCount + 1
    writeCookie(COUNT_COOKIE, shownCount, COUNT_MAX_AGE_SECONDS)
    writeCookie(SNOOZE_COOKIE, 1, snoozeSecondsAfter(shownCount))
    this.element.classList.remove("hidden")
    this.timer = setTimeout(() => this.hide(), VISIBLE_MS)
  }

  hide() {
    clearTimeout(this.timer)
    this.element.classList.add("opacity-0")
    this.timer = setTimeout(() => this.element.remove(), FADE_MS)
  }

  get shownCount() {
    return Number(readCookie(COUNT_COOKIE)) || 0
  }
}
